// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_settings_model from "./web_settings_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function path(t) {
  const workspace = Mapre_web__Web_types.workspace(Curry._1(t.model, undefined).route);
  if (workspace !== undefined) {
    return "/api/workspaces/" + (workspace + "/settings");
  } else {
    return Stdlib.invalid_arg("settings_without_workspace");
  }
}

function request(t, body, param) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, body, path(t)).then(function (result) {
    if (generation === t.generation && Curry._1(t.model, undefined).settings_form !== undefined) {
      if (result.TAG === /* Ok */ 0) {
        try {
          const action_0 = result._0;
          const action_1 = crypto.randomUUID();
          const action_2 = body !== undefined;
          const action = {
            TAG: /* Loaded */ 3,
            _0: action_0,
            _1: action_1,
            _2: action_2
          };
          Curry._1(t.emit, {
            TAG: /* Settings */ 37,
            _0: action
          });
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.emit, {
              TAG: /* Settings */ 37,
              _0: {
                TAG: /* Failed */ 4,
                _0: "Invalid settings response."
              }
            });
          } else {
            throw exn;
          }
        }
      } else {
        const code = result._0;
        if (/* tag */ typeof code !== "object" && typeof code !== "function" || code.TAG !== /* Failed */ 1) {
          Curry._1(t.emit, {
            TAG: /* Settings */ 37,
            _0: {
              TAG: /* Failed */ 4,
              _0: "Unable to access App settings."
            }
          });
          Curry._1(t.failure, code);
        } else {
          Curry._1(t.emit, {
            TAG: /* Settings */ 37,
            _0: {
              TAG: /* Failed */ 4,
              _0: code._0
            }
          });
        }
      }
    }
    return Promise.resolve();
  });
}

function load(t) {
  cancel(t);
  Curry._1(t.emit, {
    TAG: /* Settings */ 37,
    _0: /* Loading */ 3
  });
  request(t, undefined, undefined);
}

function dispatch(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Close */ 0 :
        cancel(t);
        return Curry._1(t.emit, {
          TAG: /* Settings */ 37,
          _0: /* Close */ 0
        });
      case /* Refresh */ 1 :
        if (Curry._1(t.model, undefined).settings_form !== undefined) {
          return load(t);
        }
        break;
    }
  } else if (action.TAG === /* Open */ 0 && Mapre_web__Web_types.workspace(Curry._1(t.model, undefined).route) !== undefined) {
    const action$1 = {
      TAG: /* Open */ 0,
      _0: crypto.randomUUID()
    };
    Curry._1(t.emit, {
      TAG: /* Settings */ 37,
      _0: action$1
    });
    return load(t);
  }
  const form = Curry._1(t.model, undefined).settings_form;
  if (form === undefined) {
    return;
  }
  if (form.pending) {
    return;
  }
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    if (action === /* Submit */ 2) {
      if (!(Mapre_web__Web_model.can_manage_project(Curry._1(t.model, undefined)) && Mapre_web__Web_settings_model.can_save(form))) {
        return;
      }
      Curry._1(t.emit, {
        TAG: /* Settings */ 37,
        _0: /* Pending */ 4
      });
      const body = JSON.stringify(Js__Js_dict.fromList(Stdlib.$at({
        hd: [
          "request_id",
          Mapre_wire__Json.str(form.request_id)
        ],
        tl: {
          hd: [
            "expected_version",
            Stdlib__Option.get(form.version)
          ],
          tl: {
            hd: [
              "max_concurrent_sessions",
              Stdlib__Option.get(Mapre_web__Web_settings_model.limit(form.value))
            ],
            tl: {
              hd: [
                "sandbox_provider",
                Mapre_wire__Json.str(form.provider)
              ],
              tl: /* [] */ 0
            }
          }
        }
      }, form.token === "" ? /* [] */ 0 : ({
          hd: [
            "instabox_token",
            Mapre_wire__Json.str(form.token)
          ],
          tl: /* [] */ 0
        }))));
      return request(t, body, undefined);
    } else {
      return;
    }
  }
  if (action.TAG !== /* Change */ 1) {
    return;
  }
  const action_0 = action._0;
  const action_1 = crypto.randomUUID();
  const action$2 = {
    TAG: /* Edited */ 2,
    _0: action_0,
    _1: action_1
  };
  Curry._1(t.emit, {
    TAG: /* Settings */ 37,
    _0: action$2
  });
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
